<script>
export default {
    name: 'FlagNetherlands',
}
</script>
<template>
    <svg
        class="base-flag flag-netherlands"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="28"
        height="20"
        viewBox="0 0 28 20"
    >
        <defs><path id="a" d="M0 0h28v20H0z" /></defs>
        <g fill="none" fill-rule="evenodd">
            <mask id="b" fill="#fff"><use xlink:href="#a" /></mask>
            <path
                stroke="#F5F5F5"
                stroke-width=".5"
                d="M.25.25h27.5v19.5H.25z"
            />
            <path fill="#CA2B39" d="M0 0h28v6.667H0z" mask="url(#b)" />
            <path fill="#2C56A2" d="M0 13.333h28V20H0z" mask="url(#b)" />
        </g>
    </svg>
</template>
